import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "prompt-settings" }
const _hoisted_2 = { class: "prompt-settings__item" }
const _hoisted_3 = { class: "prompt-settings__item__title" }
const _hoisted_4 = { class: "prompt-settings__item" }
const _hoisted_5 = { class: "prompt-settings__item__title" }
const _hoisted_6 = { class: "negative-items" }

import { ref } from 'vue';
import { storeToRefs } from 'pinia';

// import i18n from '@/plugins/i18n';
import { useEditorStore } from '@/store/editor';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
// import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PromptSettings',
  setup(__props) {

const { generateImageData } = storeToRefs(useEditorStore());
const negative = ref<string>('');
// const lang = computed(() => i18n.global.locale.value);

const addNegative = (): void => {
  if (negative.value.length === 0 || (negative.value.startsWith('\n') && negative.value.length === 1)) {
    negative.value = '';
    return;
  }
  generateImageData.value.negativeList.push(negative.value.replace(/[\s.,;:%]/g, ''));
  negative.value = '';
};

const removeFromNegative = (key: number): void => {
  generateImageData.value.negativeList.splice(key, 1);
};

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('editor.settings.bg-description')), 1),
      _createVNode(_component_v_textarea, {
        modelValue: _unref(generateImageData).prompt,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(generateImageData).prompt) = $event)),
        class: "prompt-settings__item__textarea prompt-settings__item__textarea--prompt",
        placeholder: _ctx.$t('editor.settings.prompt-placeholder'),
        "hide-details": "auto"
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('editor.settings.negative')), 1),
      _createVNode(_component_v_textarea, {
        modelValue: negative.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((negative).value = $event)),
        modelModifiers: { trim: true },
        onKeydown: _withKeys(_withModifiers(addNegative, ["prevent"]), ["enter","space"]),
        onBlur: addNegative,
        class: "prompt-settings__item__textarea prompt-settings__item__textarea--negative",
        placeholder: _ctx.$t('editor.settings.negative-placeholder'),
        "hide-details": "auto"
      }, null, 8, ["modelValue", "onKeydown", "placeholder"]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(generateImageData).negativeList, (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "negative-item",
            key: 'negative-list' + key
          }, [
            _createTextVNode(_toDisplayString(item) + " ", 1),
            _createVNode(AiClearButton, {
              icon: "",
              class: "negative-item__button",
              onClick: ($event: any) => (removeFromNegative(key))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/icons/editor/negative-remove.svg')
                }, null, 8, ["src"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})